import {useCallback, useState} from 'react';
import {toast} from 'react-toastify';

import {
  useSetUserAdminMutation,
  useUpdateUserRoleV2Mutation,
} from '../../../../generated/graphql';
import {UserRole} from '../../util';

export const useOnUserRoleChange = () => {
  const [updateOrganizationUserMutation] = useUpdateUserRoleV2Mutation();
  const [setUserAdmin] = useSetUserAdminMutation();
  const [isUpdating, setIsUpdating] = useState(false);

  const onUserRoleChange = useCallback(
    async (userId: string, role: UserRole) => {
      const accountType = role === 'Viewer' ? 'VIEWER' : 'USER';
      try {
        setIsUpdating(true);
        await setUserAdmin({
          variables: {
            id: userId,
            admin: role === 'Admin',
          },
        });
        await updateOrganizationUserMutation({
          variables: {
            id: userId,
            role: accountType,
          },
        });
        toast.success('User role updated');
      } catch (err) {
        toast.error('Failed to update user role');
      } finally {
        setIsUpdating(false);
      }
    },
    [setUserAdmin, updateOrganizationUserMutation]
  );

  return {
    isUpdating,
    onUserRoleChange,
  };
};
